var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgDottedLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1534 665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.8169,-84.8458)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.874494,0,0,0.874494,123.304,92.6874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-141,7C-66.333,-3.5 115.6,2.8 246,112C409,248.5 545.5,741 767,738.5C988.5,736 1353,683 1588,483.5",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(61,190,173)",
      strokeWidth: 6,
      strokeDasharray: "12,12"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1512,
    height: 742,
    style: {
      fill: "none"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDottedLine);
export default __webpack_public_path__ + "static/media/bg-dotted-line.bb0a6d1be149f172236ed614d5a4f530.svg";
export { ForwardRef as ReactComponent };